import { Routes, Route } from "react-router-dom";
import AppBar from "./components/global/AppBar";
import SideBar from "./components/global/SideBar";
import Dashboard from "./pages/SubscriberModule/Dashboard.js";
import CreateQuery from "./pages/SubscriberModule/CreateQuery";
import ViewPlan from "./pages/SubscriberModule/ViewPlan.js";
import ManageSubscription from "./pages/SubscriberModule/ManageSubscription.js";
import EditProfile from "./pages/SubscriberModule/EditProfile.js";
import ChangePlan from "./pages/SubscriberModule/ChangePlan.js";
import BotLink from "./pages/SubscriberModule/BotLink.js";
import Error404 from "./pages/Error404.js";
import { useState, useEffect } from "react";
import secureLocalStorage from "react-secure-storage";

function SubscriberModule() {
  const [subscribe, setSubscribe] = useState("");
  const [role, setRole] = useState(null);

  useEffect(() => {
    const isSubscriber = secureLocalStorage.getItem("Subscription");
    const subscriberRole = secureLocalStorage.getItem("role");
    if (isSubscriber) {
      setSubscribe(isSubscriber);
    }
    if (subscriberRole) {
      setRole(subscriberRole);
    }
  }, []);

  // Override the ResizeObserver error
  const resizeObserverLoopErr = () => {
    const errMsg = "ResizeObserver loop limit exceeded";
    if (typeof ErrorEvent !== "undefined") {
      window.addEventListener("error", (event) => {
        if (event.message === errMsg) {
          event.stopImmediatePropagation();
        }
      });
    }
  };

  resizeObserverLoopErr();

  return (
    <div className="app">
      {subscribe == true ? <SideBar /> : null}
      <main className="content">
        {role === "subscriber" && subscribe == true && <AppBar />}
        <Routes>
          <Route index element={<Dashboard />} />
          <Route
            path="/query/create"
            element={<CreateQuery isSubscribe={subscribe} />}
          />
          <Route
            path="/plan/view"
            element={<ViewPlan isSubscribe={subscribe} />}
          />
          <Route
            path="/plan/manage/subscription"
            element={<ManageSubscription isSubscribe={subscribe} />}
          />
          <Route path="/edit/profile" element={<EditProfile role={role} />} />
          <Route
            path="/plan/get/botlink"
            element={<BotLink isSubscribe={subscribe} />}
          />
          <Route
            path="/plan/change"
            element={<ChangePlan isSubscribe={subscribe} />}
          />
          <Route path="*" element={<Error404 />} />
        </Routes>
      </main>
    </div>
  );
}

export default SubscriberModule;
